import { jsx } from '@emotion/react';
import styled from '@emotion/styled';

import { connectLocation } from '../location/LocationConnectors';

const MobileFilterWrapper = styled.div`
  display: flex;
  margin: 16px 0;
  text-transform: uppercase;
  font-size: 18px;
  color: #585858;
  z-index: 10;

  @media (min-width: 1200px) {
    display: none;
  }

  a {
    cursor: pointer;
  }
`;

const FilterOpener = ({ t, className, onClick = null }) => (
  <MobileFilterWrapper className={className}>
    <a className="oc-icon" onClick={onClick}>
      <i className="icon filters" /> {t('generic_locator.filters')}
    </a>
  </MobileFilterWrapper>
);

export default connectLocation(FilterOpener);
